export default __webpack_public_path__ + "static/statsBG-46bbcdb03f1837a07c84a366f09f42da.jpg";